import React from 'react'
import Layout from '~/components/Layout'
import BoxMargin from '~/components/BoxMargin'
import { Paper, Box } from '@material-ui/core'

const FdlmMapInstallPage = () => {
  return (
    <Layout>
      <BoxMargin>
        <h1>Carte de la Fête de la Musique</h1>

        <h2>Intégration</h2>

        <p>
          Pour intégrer la carte de la Fête de la Musique sur votre site,
          ajoutez le code HTML suivant sur l'une de vos pages.
        </p>
        <p>
          Les utilisateurs de Wordpress pourront utiliser un{' '}
          <b>bloc HTML personnalisé</b>.
        </p>
        <p>
          Vous pouvez modifier les valeurs de <code>width</code> et{' '}
          <code>height</code> pour changer la largeur et la hauteur de l'iframe.
        </p>
        <textarea
          cols={100}
          rows={6}
          defaultValue={`<iframe title="Carte de la Fête de la Musique" frameBorder="0" src="https://www.melo-app.com/fdlm-map" width="100%" height="500"
></iframe>
<p>Retrouvez l'ensemble du programme sur <a href="https://fetedelamusique2021.melo-app.com">Melo-app.com</a></p>`}
        />

        <h2>Aperçu</h2>
        <Paper>
          <Box p={2}>
            <iframe
              title="Carte de la Fête de la Musique"
              frameBorder="0"
              src="https://www.melo-app.com/fdlm-map"
              width="100%"
              height="500"
            ></iframe>
            <p>
              Retrouvez l'ensemble du programme sur{' '}
              <a href="https://fetedelamusique2021.melo-app.com">
                Melo-app.com
              </a>
            </p>
          </Box>
        </Paper>
      </BoxMargin>
    </Layout>
  )
}

export default FdlmMapInstallPage

FdlmMapInstallPage.getInitialProps = async () => {
  return { namespacesRequired: [] }
}
